import { render, staticRenderFns } from "./form-row-specification-table.vue?vue&type=template&id=5918fc0e&scoped=true&"
import script from "./form-row-specification-table.vue?vue&type=script&lang=js&"
export * from "./form-row-specification-table.vue?vue&type=script&lang=js&"
import style0 from "./form-row-specification-table.vue?vue&type=style&index=0&id=5918fc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5918fc0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5918fc0e')) {
      api.createRecord('5918fc0e', component.options)
    } else {
      api.reload('5918fc0e', component.options)
    }
    module.hot.accept("./form-row-specification-table.vue?vue&type=template&id=5918fc0e&scoped=true&", function () {
      api.rerender('5918fc0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-specification-table.vue"
export default component.exports